import React from 'react';

const ProcessThree = () => {
    return (
        <section
            className="process-area-1 bg-smoke space-bottom"
            style={{ backgroundImage: "url(assets/img/bg/shape_1.png)" }}
        >
            {/* Client Area   */}
            <br />
            <br />
            <br />
            <br />
            
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="title-area text-center">
                            <span className="sub-title">
                                <img src="assets/img/icon/title_left.svg" alt="Ícone Metodologia Rocvel" />
                                Como Trabalhamos
                            </span>
                            <h2 className="sec-title style2">
                                Nossa Metodologia
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row gy-30">
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/sobrenos/3/1.png" alt="Diagnóstico Consultivo de RH" />
                                </div>
                                <h3 className="process-card_number">01</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Imersão Inicial</span>
                                <h4 className="process-card-title">Diagnóstico Consultivo</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/sobrenos/3/2.png" alt="Mapeamento de Perfil Profissional" />
                                </div>
                                <h3 className="process-card_number">02</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Inteligência de Mercado</span>
                                <h4 className="process-card-title">Mapeamento de Perfil</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/sobrenos/3/3.png" alt="Hunting e Triagem Assertiva" />
                                </div>
                                <h3 className="process-card_number">03</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Atração Avançada</span>
                                <h4 className="process-card-title">Hunting & Triagem Assertiva</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/sobrenos/3/4.png" alt="Integração e Alta Performance" />
                                </div>
                                <h3 className="process-card_number">04</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Alta Performance</span>
                                <h4 className="process-card-title">Integração & Resultados</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProcessThree;